import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonUIModule, CommonUIFieldsModule } from '@sdbn/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DictionaryModule } from '@sdbn/common';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { CommonLayoutModule, CommonTranslationModule } from '@sdbn/common';
import { TmcYardCommonModule } from '../../../common/common.module';
import { CommunicationLanguageFieldComponent } from './communication-language-field/communication-language-field.component';
import { DataProtectionFieldComponent } from './data-protectionn-rule-field/data-protection-field.component';
import { TimeslotFieldComponent } from './timeslot-field/timeslot-field.component';
import { PreloadingFieldComponent } from './preloading-field/preloading-field.component';
import { PickupTruckFieldComponent } from './pickup-truck-field/pickup-truck-field.component';
import { CarrierAutoCompleteFieldComponent } from './carrier-auto-complete-field/carrier-auto-complete-field.component';
import { DictionaryFieldComponent } from './dictionary-field/dictionary-field.component';
import { DictionarySelectFieldComponent } from './dictionary-select-field/dictionary-select-field.component';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';


import { MatRadioModule as MatRadioModule } from '@angular/material/radio';
import { MatSelectModule as MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule as MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import { MatCheckboxModule as MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
  declarations: [
    CommunicationLanguageFieldComponent,
    DataProtectionFieldComponent,
    TimeslotFieldComponent,
    PreloadingFieldComponent,
    PickupTruckFieldComponent,
    CarrierAutoCompleteFieldComponent,
    DictionaryFieldComponent,
    DictionarySelectFieldComponent
  ],
  imports: [
    CommonModule,

    FormsModule,
    ReactiveFormsModule,
    DictionaryModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    TmcYardCommonModule,
    CommonLayoutModule,
    CommonUIModule,
    CommonUIFieldsModule,
    MatRadioModule,
    MatFormFieldModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatInputModule,
    MatCheckboxModule
  ],
  exports: [
    CommunicationLanguageFieldComponent,
    DataProtectionFieldComponent,
    TimeslotFieldComponent,
    PreloadingFieldComponent,
    PickupTruckFieldComponent,
    CarrierAutoCompleteFieldComponent,
    DictionaryFieldComponent,
    DictionarySelectFieldComponent
  ]
})
export class TmcCommonFieldsModule { }
